var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: "clipboard-drawer" },
      on: { "after-leave": _vm.onDrawerTransitionLeave },
    },
    [
      _vm.value
        ? _c(
            "div",
            {
              ref: "drawerRoot",
              staticClass: "clipboard-drawer",
              class: _vm.drawerOverlayClass,
              style: _vm.drawerOverlayStyle,
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "clipboard-drawer-title",
              },
            },
            [
              _vm.showInternalBackdrop
                ? _c("div", {
                    staticClass: "clipboard-drawer__backdrop",
                    on: { click: _vm.close },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "clipboard-drawer__panel",
                  attrs: { tabindex: "-1" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "clipboard-drawer__close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.close },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", { attrs: { d: "M18 6 6 18" } }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "m6 6 12 12" } }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clipboard-drawer__head" }, [
                    _c("div", { staticClass: "clipboard-drawer__head-top" }, [
                      _c(
                        "h2",
                        {
                          staticClass: "clipboard-drawer__title",
                          attrs: { id: "clipboard-drawer-title" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "clipboard-drawer__title-icon",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "aria-hidden": "true",
                              },
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  width: "8",
                                  height: "4",
                                  x: "8",
                                  y: "2",
                                  rx: "1",
                                  ry: "1",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                                },
                              }),
                            ]
                          ),
                          _vm._v("\n            Clipboard\n          "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "clipboard-drawer__head-actions" },
                        [
                          _vm.showSaveCurrent
                            ? _c(
                                "button",
                                {
                                  staticClass: "clipboard-drawer__save-current",
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.canSaveCurrent || _vm.saving,
                                  },
                                  on: { click: _vm.saveCurrentDraft },
                                },
                                [
                                  _vm._v(
                                    "\n              Save current\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "clipboard-drawer__new-btn",
                              attrs: {
                                type: "button",
                                title: "New item",
                                "aria-expanded": _vm.showComposer
                                  ? "true"
                                  : "false",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openNewItem()
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("path", { attrs: { d: "M5 12h14" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M12 5v14" } }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "clipboard-drawer__sub" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.headerSubtitle) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "clipboard-drawer__search-wrap" },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "clipboard-drawer__search-icon",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: { cx: "11", cy: "11", r: "8" },
                            }),
                            _vm._v(" "),
                            _c("path", { attrs: { d: "m21 21-4.3-4.3" } }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.searchQuery,
                              expression: "searchQuery",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "clipboard-drawer__search-input",
                          attrs: {
                            type: "search",
                            placeholder: "Search clipboard…",
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.searchQuery },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchQuery = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "clipboard-drawer__sort-btn",
                            attrs: {
                              type: "button",
                              title: `Sort: ${_vm.sortOrder}`,
                            },
                            on: { click: _vm.toggleSortOrder },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", { attrs: { d: "m21 16-4 4-4-4" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "M17 20V4" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "m3 8 4-4 4 4" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "M7 4v16" } }),
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.sortLabel) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "clipboard-drawer__filters" },
                      _vm._l(_vm.filters, function (filter) {
                        return _c(
                          "button",
                          {
                            key: filter.value,
                            staticClass: "clipboard-drawer__filter",
                            class: {
                              "clipboard-drawer__filter--active":
                                _vm.activeFilter === filter.value,
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.setFilter(filter.value)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(filter.label) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.showComposer
                    ? _c("ClipboardComposer", {
                        ref: "composer",
                        attrs: {
                          form: _vm.form,
                          "bulk-paste": _vm.bulkPaste,
                          saving: _vm.saving,
                        },
                        on: {
                          "update:form": function ($event) {
                            _vm.form = $event
                          },
                          "update:bulkPaste": function ($event) {
                            _vm.bulkPaste = $event
                          },
                          "update:bulk-paste": function ($event) {
                            _vm.bulkPaste = $event
                          },
                          cancel: _vm.cancelComposer,
                          save: _vm.saveItem,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clipboard-drawer__scroll" }, [
                    _c(
                      "div",
                      { staticClass: "clipboard-drawer__scroll-inner" },
                      [
                        _vm.loading
                          ? _c(
                              "div",
                              { staticClass: "clipboard-drawer__empty" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "clipboard-drawer__empty-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n              Loading…\n            "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm.loadError
                          ? _c(
                              "div",
                              { staticClass: "clipboard-drawer__empty" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "clipboard-drawer__empty-title clipboard-drawer__empty-text--error",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.loadError) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "clipboard-drawer__btn clipboard-drawer__btn--ghost clipboard-drawer__retry",
                                    attrs: { type: "button" },
                                    on: { click: _vm.loadItems },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Retry\n            "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm.displayedItems.length === 0
                          ? _c(
                              "div",
                              { staticClass: "clipboard-drawer__empty" },
                              [
                                !_vm.hasActiveSearch
                                  ? _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "clipboard-drawer__empty-icon",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "32",
                                          height: "32",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "aria-hidden": "true",
                                        },
                                      },
                                      [
                                        _c("rect", {
                                          attrs: {
                                            width: "8",
                                            height: "4",
                                            x: "8",
                                            y: "2",
                                            rx: "1",
                                            ry: "1",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "clipboard-drawer__empty-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.listEmptyState.title) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "clipboard-drawer__empty-hint",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.listEmptyState.hint) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.listEmptyState.addLabel
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "clipboard-drawer__empty-add",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openNewItem(
                                              _vm.listEmptyState.addType
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "14",
                                              height: "14",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: { d: "M5 12h14" },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: { d: "M12 5v14" },
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.listEmptyState.addLabel
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "clipboard-drawer__list" },
                              _vm._l(_vm.displayedItems, function (item) {
                                return _c("ClipboardItemCard", {
                                  key: item.id,
                                  attrs: {
                                    item: item,
                                    "insert-only": _vm.insertOnly,
                                    deleting: _vm.deletingId === item.id,
                                    "inline-editing":
                                      _vm.inlineEditingId === item.id,
                                    saving:
                                      _vm.saving &&
                                      _vm.inlineEditingId === item.id,
                                    expanded: !!_vm.expandedNoteIds[item.id],
                                  },
                                  on: {
                                    insert: _vm.insertItem,
                                    copy: _vm.copyItem,
                                    delete: _vm.confirmDelete,
                                    edit: _vm.startInlineEdit,
                                    "cancel-edit": _vm.cancelInlineEdit,
                                    "save-edit": _vm.saveInlineEdit,
                                    "toggle-expand": _vm.toggleNoteExpand,
                                  },
                                })
                              }),
                              1
                            ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }